module.exports = __webpack_public_path__ + "36380dcf41e57575a3328adb5cabfcac.svg";